export const formatCo2Saved = (co2Saved) => Math.round(co2Saved);
